module.exports = __webpack_public_path__ + "img/20200531.6b47f2f2.png";